// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2zrM9","notes":"Notes_notes__Bil5H","note":"Notes_note__ebUwN","markdown":"Notes_markdown__cQYKB"};